import { Autocomplete as MuiAutocomplete, AutocompleteProps, TextField } from '@mui/material'

/**
 * Autocomplete text field with added data-cy and label.
 */
export const Autocomplete = (props: Omit<AutocompleteProps<string, false, false, true>, 'renderInput'> & { label: string, error?: boolean }): JSX.Element => {

  const { error, ...rest } = props

  return <MuiAutocomplete
    data-cy={`text-${props.label}`}
    renderInput={(params) => <TextField label={props.label} error={error} {...params}/>}
    {...rest}
  />
}
